import type { JSX } from 'react';

import { Container } from '@change-corgi/design-system-legacy/layout';

import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();

	return (
		<Container mt={[40, 100]} px={8}>
			<PageHeading />
			<PageBody />
		</Container>
	);
}
